﻿import React, {FC} from 'react';
import {Checkbox, ListItemText, MenuItem, SelectProps, Typography} from "@mui/material";
import SearchFilterChipMultiSelect from "./SearchFilterChipMultiSelect";
import EquipmentTypes from "../../../../EquipmentTypes";

const SearchFilterEquipmentSelect: FC<SelectProps<Array<string>>> = ({value, ...rest}) => {
    return <SearchFilterChipMultiSelect
        label="Equipment Type"
        value={value}
        {...rest}
    >
        {EquipmentTypes.OPTIONS_CONDENSED.map((option) => (
            // yf: Putting this in a subcomponent breaks the select: see children here: https://mui.com/material-ui/api/select/
            <MenuItem key={option} value={option}>
                <Checkbox checked={!!value && value.indexOf(option) > -1} />
                <ListItemText primary={<Typography variant='body2' fontSize={13}>{option}</Typography>} />
            </MenuItem>
        ))}
    </SearchFilterChipMultiSelect>
}

export default SearchFilterEquipmentSelect;
